module.exports = __webpack_public_path__ + "img/duck.53961ebe.png";